// ============================================
// QUOTE STATUS - one rule, everywhere
// ============================================
// A quote is "expired" once its expiry date has passed while it is still awaiting the
// client (status 'sent' or 'client_request'). The backend ACCEPTS an 'expired' status,
// but nothing stores it automatically - there is no nightly sweep - so we DERIVE it here
// and use it on every screen that shows a quote: the client's quote list, the client's
// quote page, the admin quote register and the admin quote page. One rule, so those
// screens can never disagree with each other.
//
// A quote stays valid for the WHOLE of its expiry day (date-only comparison), which
// matches the client-facing wording "expired on <date>".
// ============================================

export const isQuoteExpired = (q) => {
  if (!q) return false;
  if (q.status !== 'sent' && q.status !== 'client_request') return false;
  if (!q.expiry_date) return false;
  return new Date(q.expiry_date) < new Date(new Date().toDateString());
};

// The status to SHOW. The stored status is never altered - this is display only.
export const effectiveQuoteStatus = (q) => (isQuoteExpired(q) ? 'expired' : (q ? q.status : undefined));

// Shared look & feel for the Expired pill, so every page matches.
export const EXPIRED_META = { label: 'Expired', color: '#dc2626', bg: '#fef2f2' };
